import { z } from 'zod';

export const CleaningFrequencySchema = z.enum([
  'giornaliera',
  'settimanale',
  'mensile',
  'trimestrale',
  'semestrale',
  'annuale',
  'a_chiamata',
]);
export type CleaningFrequency = z.infer<typeof CleaningFrequencySchema>;

export const CleaningEquipmentKindSchema = z.enum([
  'macchinari_apparecchiature',
  'utensili_strumenti',
  'piani_lavoro_superfici',
  'contenitori_alimentari',
  'frigoriferi_congelatori',
  'forni_piastre_cottura',
  'lavelli_lavastoviglie',
  'attrezz_manutenzione_pulizia',
  'abbigliamento_lavoro',
  'dpi',
  'carrelli_contenitori_mobili',
  'impianti_ventilazione',
  'bilance_misura',
  'attrezz_taglio',
  'impianti_idrici',
  'pavimenti_pareti',
  'arredi_scaffalature',
  'attrezz_stoccaggio',
  'sistemi_monitoraggio',
  'superficie',
  'attrezzo',
  'area',
  'utensile',
  'altro',
]);
export type CleaningEquipmentKind = z.infer<typeof CleaningEquipmentKindSchema>;

export const CleaningEquipmentSchema = z.object({
  id: z.string().uuid(),
  tenant_id: z.string().uuid(),
  business_id: z.string().uuid(),
  name: z.string().min(1).max(200),
  kind: CleaningEquipmentKindSchema.default('altro'),
  created_at: z.string().datetime(),
  archived_at: z.string().datetime().nullable(),
  version: z.number().int().nonnegative().default(0),
});
export type CleaningEquipment = z.infer<typeof CleaningEquipmentSchema>;

export const CleaningProductCategorySchema = z.enum([
  'detergente',
  'disinfettante',
  'detersivo',
  'alcool',
  'gel_igienizzante',
  'salviette_disinfettanti',
  'spray_igienizzante',
  'candeggina',
  'sapone_liquido',
  'profumatori_ambientali',
  'detergente_superfici',
  'disinfettante_pavimenti',
  'prodotti_ospedalieri',
  'sanificante_industriale',
  'detergente_cucina',
  'disinfettante_bagno',
  'spray_antibatterico',
  'pulitore_multifunzione',
  'neutralizzante_odori',
  'sanitizzante',
  'sgrassante',
  'altro',
]);
export type CleaningProductCategory = z.infer<typeof CleaningProductCategorySchema>;

export const CleaningProductSchema = z.object({
  id: z.string().uuid(),
  tenant_id: z.string().uuid(),
  business_id: z.string().uuid(),
  name: z.string().min(1).max(200),
  category: CleaningProductCategorySchema.default('detergente'),
  safety_sheet_file_id: z.string().nullable(),
  created_at: z.string().datetime(),
  archived_at: z.string().datetime().nullable(),
  version: z.number().int().nonnegative().default(0),
});
export type CleaningProduct = z.infer<typeof CleaningProductSchema>;

// Time slot HH:mm:ss (Postgres time literal). 08:00 → "08:00:00".
const TimeSlotRegex = /^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/;
export const TimeSlotSchema = z
  .string()
  .regex(TimeSlotRegex, 'Formato HH:mm o HH:mm:ss')
  .transform((s) => (s.length === 5 ? `${s}:00` : s));

export const CleaningScheduleSchema = z.object({
  id: z.string().uuid(),
  tenant_id: z.string().uuid(),
  business_id: z.string().uuid(),
  title: z.string().min(1).max(200),
  equipment_id: z.string().uuid().nullable(),
  product_id: z.string().uuid().nullable(),
  frequency: CleaningFrequencySchema,
  instructions: z.string().nullable(),
  requires_photo: z.boolean().default(false),
  responsible_role: z.string().nullable(),
  assigned_personnel_ids: z.array(z.string().uuid()).default([]),
  time_slots: z.array(TimeSlotSchema).default([]),
  created_at: z.string().datetime(),
  archived_at: z.string().datetime().nullable(),
  version: z.number().int().nonnegative().default(0),
});
export type CleaningSchedule = z.infer<typeof CleaningScheduleSchema>;
